import { useEffect, useState } from "react";

export default function FadeTransition({ children, step }) {
  const [display, setDisplay] = useState(children);
  const [animClass, setAnimClass] = useState("fade-enter");

  useEffect(() => {
    // Start exit animation
    setAnimClass("fade-exit");

    const timeout = setTimeout(() => {
      // After exit animation -> update component, start enter animation
      setDisplay(children);
      setAnimClass("fade-enter");
    }, 200); // Should match CSS duration

    return () => clearTimeout(timeout);
  }, [step]);

  return <div className={`fade-container ${animClass}`}>{display}</div>;
}
